module.exports = __webpack_public_path__ + "static/media/S4N10-1.74fa63c6.svg";